import { gameRoutes, type GameMeta, type SimpleDate } from '@puzzlio/core';
import type { HighlightConfig } from '@puzzlio/core';
import { colors } from '@puzzlio/tokens';

export const highlightConfigs: Record<string, HighlightConfig> = {
  '1': { color: '#00805B', label: 'Green' },
  '2': { color: '#82E2F3', label: 'Blue' },
  erase: { color: '#FFFFFF', label: 'Erase' },
};

export const meta: GameMeta = {
  type: 'fields',
  gameId: 3,
  label: 'Fields',
  description: 'Fill the grid with colorful fields that never connect',
  emoji: '🌾',
  buttonColor: 'green',
  // Neither of these is a palette entry; the page's green sits between green-100 and green-200.
  background: { fill: '#caf5e3', dot: '#b5f2d4' },
  burst: { inner: colors['green-300'], outer: colors['green-200'] },
  separator: colors['green-600'],
  earliestDate: '2025-11-01' as SimpleDate,
  tutorialSlug: 'tutorial',
  practiceCollections: [
    { level: 1, puzzles: ['easy-1', 'easy-2', 'easy-3'] },
    { level: 2, puzzles: ['medium-1', 'medium-2', 'medium-3'] },
    { level: 3, puzzles: ['hard-1', 'hard-2', 'hard-3'] },
  ],
  enableHints: true,
  availability: 'available',
  highlightConfigs: highlightConfigs,
  ...gameRoutes('/games/fields'),
};
